import { Navigate } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";

const ProtectedRoute = ({ children, adminOnly }) => {
  const { token, user } = useContext(AuthContext);
  const isAdmin =
    String(user?.email || "").toLowerCase() === "admin@gmail.com" ||
    String(user?.role || "").toLowerCase() === "admin";

  if (!token || !user) return <Navigate to="/login" />;

  if (adminOnly && !isAdmin)
    return <Navigate to="/student" />;

  return children;
};

export default ProtectedRoute;
